import React from 'react';
import PropTypes from 'prop-types';
import { BaseEdge, getBezierPath, useStore } from '@xyflow/react';

// const hasConfig = (n) => {
//   if (!n) return false;
//   const cfg = n?.data?.config || {};
//   const label = (n?.data?.label || '').toLowerCase();
//   const isJira = label.includes('jira');
//   if (!cfg.connection?.conn_id) return false;
//   if (isJira) return !!cfg.project?.id || !!cfg.project?.key;
//   return !!cfg.module;
// };

export default function SideAwareEdge(props) {
  const {
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    source,
    target,
    style,
    data,
  } = props;
  const src = useStore((s) => s?.nodeInternals?.get?.(source));
  const tgt = useStore((s) => s?.nodeInternals?.get?.(target));

  const calc = (n) => {
    if (!n) return false;
    const c = n?.data?.config || {};
    const isJira = String(n?.data?.label || '')
      .toLowerCase()
      .includes('jira');
    if (!c.connection?.conn_id) return false;
    return isJira ? !!(c.project?.id || c.project?.key) : !!c.module;
  };

  const srcOk = data?.sourceOk ?? calc(src);
  const tgtOk = data?.targetOk ?? calc(tgt);

  // Check if edge is connected to a backtrack node
  const isBacktrackEdge =
    src?.type === 'backtrackNode' || tgt?.type === 'backtrackNode';

  const [edgePath] = getBezierPath({ sourceX, sourceY, targetX, targetY });

  // Use purple for backtrack edges, otherwise use default blue
  const edgeColor = isBacktrackEdge ? '#9c27b6' : '#1976d2';

  if (srcOk && tgtOk) {
    return (
      <BaseEdge
        path={edgePath}
        style={{ stroke: edgeColor, strokeWidth: 2.2, ...style }}
      />
    );
  }
  if (!srcOk && !tgtOk) {
    return (
      <BaseEdge
        path={edgePath}
        style={{
          stroke: 'red',
          strokeWidth: 2.2,
          filter: 'drop-shadow(0 0 6px red)',
          ...style,
        }}
      />
    );
  }

  const gradId = `grad-${id}`;
  const startColor = edgeColor;
  const endColor = edgeColor;

  return (
    <>
      <defs>
        <linearGradient
          id={gradId}
          gradientUnits="userSpaceOnUse"
          x1={sourceX}
          y1={sourceY}
          x2={targetX}
          y2={targetY}
        >
          <stop offset="0%" stopColor={startColor} />
          <stop offset="100%" stopColor={endColor} />
        </linearGradient>
      </defs>
      <BaseEdge
        path={edgePath}
        style={{ stroke: `url(#${gradId})`, strokeWidth: 2.2, ...style }}
      />
    </>
  );
}

SideAwareEdge.propTypes = {
  id: PropTypes.string.isRequired,
  sourceX: PropTypes.number.isRequired,
  sourceY: PropTypes.number.isRequired,
  targetX: PropTypes.number.isRequired,
  targetY: PropTypes.number.isRequired,
  source: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  style: PropTypes.object,
  data: PropTypes.object,
};
